import React from "react";
import PropTypes from "prop-types";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { lighten, makeStyles } from '@material-ui/core/styles';
/**
 *
 * @param {
 *  columns: Object Array { id: string, numeric: number, disablePadding: bool, label: string },
 *  onSelectAllClick: Function for handling all rows selection,
 *  order: String for choosing a descending or ascending order: "asc", "desc",
 *  orderBy: String for identifying the field to sort by,
 *  numSelected: Number of total selected rows,
 *  rowCount: Number of total rows,
 *  onRequestSort: Function for handling the sorting request
 * } props
 * @returns EnhancedTableHead
 */
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

const EnhancedTableHead = (props) => {
  const {
    columns,
    order,
    orderBy,
    onRequestSort,
  } = props;

  // Acceso al objeto de estilos
  const classes = useStyles();

  // Función para encapsular la solicitud de sorting.
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  // Creación de columnas para el header.
  const headerCells = columns.map((column) => (
    <TableCell
      key={column.id}
      align={column.numeric ? "right" : "left"}
      padding={column.disablePadding ? "none" : "normal"}
      sortDirection={orderBy === column.id ? order : false}
    >
      <TableSortLabel
        active={orderBy === column.id}
        direction={orderBy === column.id ? order : "asc"}
        onClick={createSortHandler(column.id)}
      >
        {column.label}
        {orderBy === column.id ? (
          <span className={classes.visuallyHidden}>
            {order === "desc" ? "sorted descending" : "sorted ascending"}
          </span>
        ) : null}
      </TableSortLabel>
    </TableCell>
  ));

  return (
    <TableHead>
      <TableRow>
        {headerCells}
      </TableRow>
    </TableHead>
  );
};

// Props definidas para el componente.
EnhancedTableHead.propTypes = {
  columns: PropTypes.array.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

export default EnhancedTableHead;
